import { Box } from '@mui/material';

export const DialogInfoContent = ({ children }) => {
  return <Box sx={{ p: 2 }}>{children}</Box>;
};

export default DialogInfoContent;
